module.exports = __webpack_public_path__ + "media/Vuma-Manifesto-Snip.6f35f8ef.mp4";